<script>
import { mapState } from 'vuex'
import CropImage from '@/components/presentations/CropImage.vue'
import CropImageV2 from '@/components/presentations/CropImage.v2.vue'

// This is an V2 adapter for V1
// Used to support V2 without breaking V1
// It has the UI UX of V1, but the logic is the same as V2
export default {
  extends: CropImage,
  props: {
    updateInBackground: {
      type: Function,
      default: null,
    },
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    handleSaveButtonClick(data) {
      CropImageV2.methods.handleSaveButtonClick.call(this, data)
    },
  },
}
</script>
